export const appTheme = {
  budgetColor: '#B5F5EC',
  forecastActualColor: '#9cc5ff',
  forecastColor: '#d2e4ff'
}
